// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2nBL9","header":"MergedInvoice_header__NDzfh"};